import { alpha, Container, useTheme } from "@mui/material";
import { ContactPageBody } from "./components/contact-page-body";

export const ContactPage = () => {
	const { palette } = useTheme();
	return (
		<Container
			maxWidth={false}
			sx={{
				overflowX: "hidden",
				backgroundColor: alpha(palette.primary.main, 0.8),
				width: "80vw",
				margin: "0 10vw",
				marginBottom: "10vw",
			}}
		>
			<ContactPageBody />
		</Container>
	);
};
